import { Alert, Col, Form, Row } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import GeneralTimePeriodesSelect from "apps/Common/GeneralTimePickerSelect";
import { handleSetSummaryReportFilter } from "../ClientSideStates";
import GeneralStoreByUser from "apps/Common/GeneralStoreByUser";
import { FC, useEffect } from "react";

const TopFilters: FC<{ isMobile: boolean }> = ({ isMobile }) => {
  const dateOptions: Record<
    string,
    { label: string; value: string; OrderDateMin: string; OrderDateMax: string }
  > = {
    Today: {
      label: "Bugün",
      value: "Today",
      OrderDateMin: dayjs().format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    Yesterday: {
      label: "Dün",
      value: "Yesterday",
      OrderDateMin: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    ThisWeek: {
      label: "Bu Hafta",
      value: "ThisWeek",
      OrderDateMin: dayjs().startOf("isoWeek").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastSevenDays: {
      label: "Son 7 Gün",
      value: "LastSevenDays",
      OrderDateMin: dayjs().subtract(7, "day").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastFifteenDays: {
      label: "Son 15 Gün",
      value: "LastFifteenDays",
      OrderDateMin: dayjs().subtract(15, "day").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    ThisMonth: {
      label: "Bu Ay",
      value: "ThisMonth",
      OrderDateMin: dayjs().startOf("month").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastThirtyDays: {
      label: "Son 30 Gün",
      value: "LastThirtyDays",
      OrderDateMin: dayjs().subtract(30, "day").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastMonth: {
      label: "Geçen Ay",
      value: "LastMonth",
      OrderDateMin: dayjs()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD"),
      OrderDateMax: dayjs()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD"),
    },
    ThisYear: {
      label: "Bu Yıl",
      value: "ThisYear",
      OrderDateMin: dayjs().startOf("year").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastYear: {
      label: "Geçen Yıl",
      value: "LastYear",
      OrderDateMin: dayjs()
        .subtract(1, "year")
        .startOf("year")
        .format("YYYY-MM-DD"),
      OrderDateMax: dayjs()
        .subtract(1, "year")
        .endOf("year")
        .format("YYYY-MM-DD"),
    },
    Custom: {
      label: "Özel Tarih Aralığı",
      value: "Custom",
      OrderDateMin: "",
      OrderDateMax: "",
    },
  };
  const [form] = Form.useForm();
  const { filter } = useSelector((state: RootState) => state.summaryReport);
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const dispatch = useDispatch();
  const handleChangeStore = (value: string) => {
    const currentFilter = { ...filter };
    if (value) {
      currentFilter["storeId"] = value;
    } else {
      delete currentFilter["storeId"];
    }
    dispatch(handleSetSummaryReportFilter({ filter: currentFilter }));
  };
  useEffect(() => {
    const startDate = filter?.StartDate ? dayjs(filter?.StartDate) : null;
    const endDate = filter?.EndDate ? dayjs(filter?.EndDate) : null;
    const customDate = [];
    if (startDate) {
      customDate.push(startDate);
    }
    if (endDate) {
      customDate.push(endDate);
    }
    const selectedOption = Object.values(dateOptions).find((option) => {
      return (
        option.OrderDateMin === dayjs(startDate).format("YYYY-MM-DD") &&
        option.OrderDateMax === dayjs(endDate).format("YYYY-MM-DD")
      );
    });
    form.setFieldsValue({
      storeId: filter?.storeId || undefined,
      date: selectedOption
        ? selectedOption.value
        : filter?.StartDate || filter.EndDate
        ? "Custom"
        : undefined,
      customDate: customDate,
    });
  }, [filter]);

  console.log("filter",filter)
  return (
    <>
      <Row gutter={[10, 10]}>
        <Col xs={24}>
          <Form form={form}>
            <Row gutter={[10, 10]}>
              {isMobile && (
                <Col xs={24}>
                  <Alert
                    message="Filtreler seçim yapıldığında otomatik uygulanır"
                    className="!text-xs sm:!text-sm"
                    type="info"
                  />
                </Col>
              )}

              <GeneralTimePeriodesSelect
                xs={24}
                md={12}
                lg={8}
                xl={6}
                form={form}
                isMobile={isMobile}
                filter={filter}
                dateOptions={dateOptions}
                actionFunc={handleSetSummaryReportFilter}
                size={"large"}
              />

              <GeneralStoreByUser
                xs={24}
                size="large"
                label={isMobile ? "Mağaza" : ""}
                md={12}
                lg={8}
                xl={6}
                allowClear
                name={"storeId"}
                onChange={handleChangeStore}
                placeholder="Mağaza"
                externalValueId={userInfoes.id}
              />
            </Row>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default TopFilters;
